"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _EllipsisDropdown = _interopRequireDefault(require("../../../../components/shared-components/EllipsisDropdown"));

var _Flex = _interopRequireDefault(require("../../../../components/shared-components/Flex"));

var _utils = _interopRequireDefault(require("../../../../utils"));

var _icons = require("@ant-design/icons");

var _editDetails = _interopRequireDefault(require("./editDetails"));

var _errorPage = _interopRequireDefault(require("./../../../error-views/errorPage"));

// import { useHistory } from 'react-router';
// import MoreTableData from './moreTableData';
// import FormView from "./editDetails"
//  import CardData from './CardData';
// const innerwidth=window.innerWidth;
// const { Option } = Select;
var TableData = function TableData(_ref) {
  var data = _ref.data;

  // const [form] = Form.useForm();
  // const cl = localStorage.getItem("CL");
  // const token = localStorage.getItem("token");
  // const history = useHistory();
  var _useState = (0, _react.useState)(data),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      tableData = _useState2[0],
      setTableData = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      edit = _useState4[0],
      setEdit = _useState4[1];

  var _useState5 = (0, _react.useState)({}),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      editDetail = _useState6[0],
      setEditDetail = _useState6[1];

  var _useState7 = (0, _react.useState)(true),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      loading = _useState8[0],
      setLoading = _useState8[1]; // const [apiError, setapiError] = useState(null);


  var _useState9 = (0, _react.useState)(null),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 1),
      apiError = _useState10[0]; // useEffect(async () => {
  //   setTableData(data);
  //   setLoading(false)
  // }, [data]);


  (0, _react.useEffect)(function () {
    function fetchData() {
      return _fetchData.apply(this, arguments);
    }

    function _fetchData() {
      _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setTableData(data);
                setLoading(false);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetchData.apply(this, arguments);
    }

    fetchData(); // eslint-disable-next-line 
  }, [data]);
  var tableColumns = [{
    title: "RM Code",
    date: 'Date',
    dataIndex: "RM_code",
    key: "RM_code",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'RM_code');
    }
  }, {
    title: "CL Code",
    dataIndex: "CL_code",
    key: "CL_code",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'CL_code');
    }
  }, {
    title: "Date",
    dataIndex: "Today_Date",
    key: "Today_Date",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'Today_Date');
    }
  }, {
    title: "END Date",
    dataIndex: "Date",
    key: "Date",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'Date');
    }
  }, {
    title: "Attendance",
    dataIndex: "Attendance",
    key: 'Attendance',
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'Attendance');
    }
  }, {
    title: 'Action',
    dataIndex: 'actions',
    fixed: "left",
    render: function render(_, elm) {
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_EllipsisDropdown.default, {
        menu: dropdownMenu(elm)
      }));
    }
  }];

  var EditRM = function EditRM(detail) {
    setEdit(true);
    setEditDetail(detail);
  };

  var dropdownMenu = function dropdownMenu(elm) {
    return /*#__PURE__*/_react.default.createElement(_antd.Menu, null, /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, null, /*#__PURE__*/_react.default.createElement(_Flex.default, {
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "ml-2",
      onClick: function onClick() {
        return EditRM(elm);
      }
    }, /*#__PURE__*/_react.default.createElement(_icons.EditOutlined, {
      className: "mr-1"
    }), "Edit"))));
  };

  return apiError ? /*#__PURE__*/_react.default.createElement(_errorPage.default, {
    details: apiError
  }) : loading ? /*#__PURE__*/_react.default.createElement(_antd.Spin, {
    tip: "Loading..."
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Table, {
    columns: tableColumns,
    dataSource: tableData,
    rowKey: "RM_code" // expandable={{
    //   expandedRowRender: record => {
    //     return <MoreTableData record={record} />;
    //   }
    // }}

  }), edit ? /*#__PURE__*/_react.default.createElement(_editDetails.default, {
    onCancel: function onCancel() {
      return setEdit(false);
    },
    item: editDetail,
    showEdit: edit
  }) : "");
};

var _default = TableData;
exports.default = _default;